module.exports = __webpack_public_path__ + "img/Documents-Active.2d852bd2.svg";